export default __webpack_public_path__ + "static/media/CNo.66-1.1906828a.jpg";